// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__28OsL","bigColWidth":"Table_bigColWidth__i0dMh","biggerColWidth":"Table_biggerColWidth__a_2nG","row":"Table_row__1X0dO","col":"Table_col__1_mz3"};